import Tdg_ProfessionModelBase from '../_generated/modelBases/tdg-profession-model-base';

export default class Tdg_ProfessionModel extends Tdg_ProfessionModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
